import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  employmentType: {
    id:
      'views.JobOfferArticleView.JobOfferArticle.ArticleContent.employmentType',
    defaultMessage: 'Rodzaj zatrudnienia:'
  },
  salary: {
    id: 'views.JobOfferArticleView.JobOfferArticle.ArticleContent.salary',
    defaultMessage: 'Wynagrodzenie:'
  },
  offerDescription: {
    id:
      'views.JobOfferArticleView.JobOfferArticle.ArticleContent.offerDescription',
    defaultMessage: 'Opis oferty:'
  },
  joinUs: {
    id: 'views.JobOfferArticleView.JobOfferArticle.ArticleContent.joinUs',
    defaultMessage: 'Dołącz do nas wysyłając swoje CV!'
  }
});



// WEBPACK FOOTER //
// ./src/views/JobOfferArticle/components/Article/ArticleContent/ArticleContent.intl.js